import ProducersWithoutAccess from "@/modules/ProducersWithoutAccess/pages/ProducersWithoutAccess"

export default [
	{
		path: '/producers-without-access',
		name: 'ProducersWithoutAccess',
		component: ProducersWithoutAccess
	}
];
